import { SearchPageView } from 'utils/search-page-view';
const headerTopClear = { top: 0 };
/**
 * The mobile search page hides the global header on the map view so the
 * search controls and spot details can sit at the top of the viewport.
 */
export const shouldShowAppHeader = ({ pathname, isMobile, view, partner, }) => {
    const isSearchPage = pathname === '/search';
    const appleMapsPartner = partner === 'apple' || partner === 'appleTest';
    if (!isSearchPage || !isMobile) {
        return true;
    }
    return view === SearchPageView.MOBILE_LIST || appleMapsPartner;
};
/**
 * Clears the header offsets on elements positioned below the header when it is hidden.
 */
export const getAppHeaderStyling = (showHeader) => ({
    '.main': showHeader ? undefined : headerTopClear,
    '.SpotListSearchControlsCondensed': {
        '.Search-map-view': showHeader ? undefined : headerTopClear,
        top: showHeader ? undefined : 0,
    },
    '.SpotDetailsReservationSummary-sticky.showing': {
        transform: showHeader ? undefined : 'translateY(0%)',
    },
    '.SpotDetailsResponsive .CheckoutSectionStickyResponsive.visible': {
        transform: showHeader ? undefined : 'translateY(0%)',
    },
});
